import { toast } from '@oliasoft-open-source/react-ui-library';
import { useState, useEffect } from 'react';

const errMesg = (msg: any) => {
  toast({
    message: {
      type: 'Error',
      icon: true,
      content: 'error',
      details: msg?.toString(),
    }, 
  });
};

export function useFetch<T, I>(httpCall: Function, mapper: Function | null, deps: I, ...args: any): { response: T | null, isLoading: boolean, errMesg: (msg: string) => void } {
  const [isLoading, setIsLoading] = useState(true);
  const [response, setResponse] = useState(null);
  const toggleOff = () => setIsLoading(false);

  useEffect(() => {
    setIsLoading(true);
    httpCall(...args)
      .then((res: any) => {
        if (mapper) {
          return mapper(res);
        }
        return res;
      })
      // @ts-ignore
      .then(setResponse)
      .catch(errMesg)
      .finally(toggleOff);
  }, [...deps as []]);

  return { response, isLoading, errMesg };
}